import { makeAutoObservable } from "mobx";
import { RArray } from "../../../collections";
export class OnlineFulfillmentFormController {
    constructor(params) {
        this.type = "Online";
        this.isFulfillmentEditable = true;
        this.fulfillmentMethodController = params.fulfillmentMethodController;
        this.userNoteController = params.userNoteController;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        makeAutoObservable(this);
    }
    get fields() {
        return {
            ...this.fulfillmentMethodController.fields,
            ...this.userNoteController.fields,
        };
    }
    get controllersArray() {
        return new RArray([
            this.fulfillmentMethodController,
            this.userNoteController,
        ]);
    }
    get isDirty() {
        return this.controllersArray.some((controller) => controller.isDirty);
    }
    get isTouched() {
        return this.controllersArray.some((controller) => controller.isTouched);
    }
    get isInvalid() {
        return this.controllersArray.some((controller) => controller.isInvalid);
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.fulfillmentInstructions;
    }
    submit() {
        this.controllersArray.forEach((controller) => controller.submit());
    }
}
